import { render, staticRenderFns } from "./search-boxset-alert.vue?vue&type=template&id=bff2ffa4&"
import script from "./search-boxset-alert.vue?vue&type=script&lang=js&"
export * from "./search-boxset-alert.vue?vue&type=script&lang=js&"
import style0 from "./search-boxset-alert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports